var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Green-Arrow-up",
    transform: "translate(-2.000000, -1.000000)",
    fill: "#006600"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.5 C17.5228475,1.5 22,5.9771525 22,11.5 C22,17.0228475 17.5228475,21.5 12,21.5 C6.4771525,21.5 2,17.0228475 2,11.5 C2,5.9771525 6.4771525,1.5 12,1.5 Z M12,6.5 L7,11.5 L10,11.5 L10,17.5 L14,17.5 L14,11.5 L17,11.5 L12,6.5 Z",
    id: "Icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgrade-icon.594c681673b2c4cbcfe8e9800c6155b2.svg";
export { ForwardRef as ReactComponent };